export const DEMO_PAYMENT_METHOD: PaymentMethod = {
  allow_redisplay: 'unspecified',
  billing_details: {
    address: { city: null, country: 'US', line1: null, line2: null, postal_code: null, state: null },
    email: null,
    name: null,
    phone: null
  },
  card: {
    brand: 'visa',
    checks: { address_line1_check: null, address_postal_code_check: null, cvc_check: null },
    country: 'US',
    display_brand: 'visa',
    exp_month: 12,
    exp_year: 2099,
    funding: 'credit',
    generated_from: null,
    last4: '4242',
    networks: { available: ['visa'], preferred: null },
    three_d_secure_usage: { supported: false },
    wallet: null
  },
  created: 0,
  customer: null,
  livemode: false,
  radar_options: {},
  id: 'demo_test_card',
  type: 'card'
}
